import React from "react";
import { Link } from "react-router-dom";
import "./Styles/Footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-grid" aria-hidden="true" />
            <div className="footer-inner">
                <div className="footer-brand-block">
                    <span className="footer-mark">DCRT</span>
                    <p className="footer-tagline">
                        Dalhousie Combat Robotics — student-built combat machines, systems engineering, and competition.
                    </p>
                </div>
                <nav className="footer-nav" aria-label="Footer">
                    <Link to="/">Home</Link>
                    <Link to="/Timeline">Timeline</Link>
                    <Link to="/GetInvolved">Get involved</Link>
                    <Link to="/Sponsors">Sponsors</Link>
                    <Link to="/blogs">Blog</Link>
                </nav>
                <p className="footer-copy">
                    © {new Date().getFullYear()} Dalhousie Combat Robotics. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
